import React from "react";
import { Modal, Box, Typography, Button, Backdrop } from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 520,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "8px",
  textAlign: "center",
};

export default function EtdrsMoveConfirmModal({
  open,
  onConfirm,
  onCancel,
}) {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
        sx: { bgcolor: "rgba(0, 0, 0, 0.7)" },
      }}
    >
      <Box sx={style}>
        <Typography variant="h6" gutterBottom>
          Are you sure you want to place ETDRS at this new position?
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Confirming will recompute volumes with the updated ETDRS center.
        </Typography>
        <Box display="flex" justifyContent="center" gap={2}>
          <Button variant="contained" color="primary" onClick={onConfirm}>
            Yes
          </Button>
          <Button variant="outlined" color="secondary" onClick={onCancel}>
            No
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
